// A small status banner. role="alert" so screen readers announce errors.
interface BannerProps {
  kind: "error" | "ok";
  children: React.ReactNode;
}

export function Banner({ kind, children }: BannerProps) {
  return (
    <div
      className={`banner ${kind === "error" ? "banner-error" : "banner-ok"}`}
      role={kind === "error" ? "alert" : "status"}
    >
      {children}
    </div>
  );
}
